export default {
    'ERROR-GET-USER-REWARDS-ADMIN': {
    // No explicit service-thrown error in getAllPurchasedForAdmin — safe fetch, no additional mapping needed.
    },
    'ERROR-MARK-REWARD-DISTRIBUTED': {
        'USER-REWARD-NOT-FOUND': {
            actionType: 'toast',
            message: {
                fr: "Récompense utilisateur introuvable.",
                en: "User reward not found.",
            },
        },
        'USER-REWARD-ALREADY-DISTRIBUTED': {
            actionType: 'toast',
            message: {
                fr: "Récompense déjà distribuée.",
                en: "Reward already distributed.",
            },
        },
    },
};
